<template>
  <div class="flex items-center">
    <span class="w-33" @click="onClickAudience">
      <VueFeather
        type="file-text"
        class="mt-3 mr-3 cursor-pointer feather-icon feather-icon"
      />
    </span>
    <span class="w-33" @click="onClickRegister">
      <VueFeather
        v-if="this.params.data.status !== 'FAILED' && this.params.data.advertiserType === 'SPONSORED_ADS'"
        type="plus-circle"
        class="mt-3 mr-3 cursor-pointer feather-icon feather-icon"
      />
    </span>
    <span class="w-33" @click="onClickDelivery">
      <VueFeather
        v-if="this.params.data.deliveries > 0"
        type="folder"
        class="mt-3 cursor-pointer feather-icon feather-icon"
      />
    </span>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DataTableCellAudience',
  data () {
    return {
      rowIndex: null
    }
  },
  beforeMount () {
    this.rowIndex = this.params.rowIndex
  },
  methods: {
    onClickAudience () {
      this.params.onClickAudience({
        index: this.rowIndex
      })
    },
    onClickRegister () {
      this.params.onClickRegister({
        index: this.rowIndex
      })
    },
    onClickDelivery () {
      this.params.onClickDelivery({
        index: this.rowIndex
      })
    }
  }
})
</script>

<style scoped>

</style>
